import { Navigate } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { useAuth } from "../lib/auth";
import { CrudManager } from "../components/admin/CrudManager";
import { RequestsManager } from "../components/admin/RequestsManager";
import { OrdersTable } from "../components/admin/OrdersTable";
import { CheckinPanel } from "../components/admin/CheckinPanel";
import { ADMIN_CONFIG } from "../components/admin/config";
import Studio from "./Studio";

const TABS = [
  ["concerts", "Concerts"], ["merch", "Merch"], ["gallery", "Gallery"], ["bookings", "Bookings"],
  ["features", "Features"], ["studio", "Studio requests"], ["orders", "Orders"], ["checkin", "Door check-in"], ["logo", "Logo loop"],
];

export default function AdminPage() {
  const { user, logout } = useAuth();
  if (user === null) return null;
  if (!user || user.role !== "admin") return <Navigate to="/login?admin=1" replace />;

  return (
    <section className="px-5 lg:px-12 pt-12" data-testid="admin-dashboard">
      <div className="flex items-end justify-between gap-4 mb-8">
        <div>
          <p className="font-cond uppercase tracking-[0.35em] text-sm text-lime">Admin</p>
          <h1 className="font-gothic text-5xl sm:text-6xl">Dashboard</h1>
        </div>
        <button onClick={logout} data-testid="admin-logout-button" className="btn-line rounded-full px-5 py-2.5 font-cond uppercase tracking-widest text-sm">Log out</button>
      </div>
      <Tabs defaultValue="concerts">
        <TabsList className="bg-[#12141a] border border-[#222634] h-auto flex flex-wrap justify-start p-1 gap-1">
          {TABS.map(([k, label]) => (
            <TabsTrigger key={k} value={k} data-testid={`admin-tab-${k}`}
              className="font-cond uppercase tracking-widest text-slate-400 data-[state=active]:bg-[#00d436] data-[state=active]:text-black">
              {label}
            </TabsTrigger>
          ))}
        </TabsList>
        {["concerts", "merch", "gallery"].map((k) => (
          <TabsContent key={k} value={k} className="mt-8"><CrudManager {...ADMIN_CONFIG[k]} /></TabsContent>
        ))}
        {["bookings", "features", "studio"].map((k) => (
          <TabsContent key={k} value={k} className="mt-8"><RequestsManager kind={k} /></TabsContent>
        ))}
        <TabsContent value="orders" className="mt-8"><OrdersTable /></TabsContent>
        <TabsContent value="checkin" className="mt-8"><CheckinPanel /></TabsContent>
        <TabsContent value="logo" className="mt-8 -mx-5 lg:-mx-12"><Studio /></TabsContent>
      </Tabs>
    </section>
  );
}
